import { render, staticRenderFns } from "./AktifAnketler.vue?vue&type=template&id=5100dd36&scoped=true"
import script from "./AktifAnketler.vue?vue&type=script&lang=js"
export * from "./AktifAnketler.vue?vue&type=script&lang=js"
import style0 from "./AktifAnketler.vue?vue&type=style&index=0&id=5100dd36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5100dd36",
  null
  
)

export default component.exports